<template>
  <v-container> Success </v-container>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const route = useRoute();
const router = useRouter();

onMounted(() => {
  console.log(
    "route.query.session_id",
    route,
    route.params,
    route.params.checkout_id
  );
  const checkoutId = route.params.checkout_id;

  axios
    .post("/api/stripe/checkout-complete", {
      checkout: checkoutId,
      licence: route.params.licence_id
    })
    .then(() => {
      console.log("Success");
    });
});
</script>
